export default __webpack_public_path__ + "static/media/logo-white.5ee80344.svg";